/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var useValueHistory = function useValueHistory(value) {
  var history = react.useRef([]);
  react.useEffect(function () {
    history.current.push(value);
  }, [value]);
  return history.current;
};

exports.default = useValueHistory;
